import React, { Component } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

import { PrivateAppRouter } from "./routes/PrivateAppRoutes";
import { PublicAppRouter } from "./routes/PublicAppRoutes";

import AuthService from "./services/auth.service";

const isAuthenticated = AuthService.isAuthenticated();

class App extends Component {
  render() {
    return (
      <BrowserRouter >
        
        <Routes>
        {
          isAuthenticated === true
          ? < Route path="/*" element={<PrivateAppRouter/>} />
          : <Route path="/*" element={ <PublicAppRouter />}  />
        }
      </Routes>
        
       
      </BrowserRouter>
    );
  }
}

export default App;
